import { FacilityModel } from "src/app/models/facility";

export interface FacilitiesState
{
    activeModel:FacilityModel;
    models: Record<string, Partial<FacilityModel>>;
    mine: string[];
}

export const FACILITIES_FEATURE_KEY = 'facilities';